import type { AncestryDefinition, CharacterOptions } from '../../shared/game/character-build.js';

export const elf: AncestryDefinition = {
  id: 'elf', name: 'Elf', size: 'medium', trait: 'Lithe', skillBonus: 0, initiativeBonus: 0, initiativeAdvantage: true, speedBonus: 1,
  description: 'Elves epitomize swiftness and grace. Their tall, slender forms belie their innate speed, grace, and wit. Formidable in both diplomacy and combat, elves strike swiftly, often preventing the worst by acting first.',
  traitDescription: 'Advantage on Initiative, +1 Speed.',
  languages: [{ id: 'elvish', name: 'Elvish', minimumIntelligence: 0 }],
  languageDescription: 'You know Elvish if your INT isn’t negative.',
  skinColors: [0xe2bd9c, 0xcfa483, 0xb78362, 0x966347, 0x75482f, 0x4e3227, 0xb1b0b7, 0x85838f, 0x56515f, 0x51405d, 0x382a46, 0x271e33],
  hairColors: [0x1c1714, 0x382c29, 0x422d25, 0x6b4428, 0x9a6a3c, 0xc9a165, 0xa64b2a, 0x8f8a84, 0xd6d2dd, 0xebe7df],
};
export const elfBodies: CharacterOptions['bodies'] = [
  { id: 'elf-male', name: 'Masculine', height: [1.85, 2.1], ancestryId: 'elf' },
  { id: 'elf-female', name: 'Feminine', height: [1.75, 2], ancestryId: 'elf' },
];
